export enum ThreeActionTypes {
  THREE_RESET = 'THREE_RESET',
  SET_SCENE_LOADED = 'SET_SCENE_LOADED',
  SET_CONTROLS_ENABLED = 'SET_CONTROLS_ENABLED',
  
  SET_BAG_LOADED = 'LOAD_BAG_LOADED',
  SET_ANIMATION_FINISHED = 'SET_ANIMATION_FINISHED',

  SET_TEX_DEFAULT_N = 'SET_TEX_DEFAULT_N',
  SET_TEX_BODY = 'SET_TEX_BODY',
  SET_TEX_BODY_N = 'SET_TEX_BODY_N',
}
